/* Cookie banner.
   Phones: it is moved to the very end of the page (see cv-theme.css), so it never floats over content. It is moved at most a few
   times: if the banner script puts it back, we stop fighting it instead of looping.
   Desktop: it is a slim bar along the bottom; its height is published as --cv-banner-h so the sticky buy bar and the Rewards launcher
   sit above it while it is showing. */
(function () {
  var phone = window.matchMedia('(max-width: 749px)');
  var moves = 0;
  var mo;
  var ro;
  var root = document.documentElement;
  function publish() {
    var bar = document.getElementById('shopify-pc__banner');
    var h = 0;
    if (bar && !phone.matches) {
      var s = getComputedStyle(bar);
      if (s.position === 'fixed' && s.display !== 'none' && s.visibility !== 'hidden') h = Math.round(bar.getBoundingClientRect().height);
    }
    root.style.setProperty('--cv-banner-h', h + 'px');
  }
  function place() {
    var bar = document.getElementById('shopify-pc__banner');
    if (bar && window.ResizeObserver && !bar.__cvro) { bar.__cvro = true; ro = new ResizeObserver(publish); ro.observe(bar); }
    publish();
    if (!bar || !phone.matches || bar === document.body.lastElementChild) return;
    if (moves >= 3) { if (mo) mo.disconnect(); return; }
    moves++;
    document.body.appendChild(bar);
  }
  mo = new MutationObserver(place);
  mo.observe(document.body, { childList: true });
  phone.addEventListener('change', function () { moves = 0; place(); });
  window.addEventListener('resize', publish);
  place();
})();
